/**
 * Код погоды → значок и словесное описание неба.
 * Коды WMO, те же, что отдаёт Open-Meteo.
 */
export type SkyIcon =
  | "sun" | "moon" | "cloud-sun" | "cloud-moon" | "cloud"
  | "drizzle" | "rain" | "snow" | "fog" | "storm";

export function skyIcon(code: number, isDay: boolean): SkyIcon {
  if (code >= 95) return "storm";
  if (code >= 71 && code <= 77) return "snow";
  if (code === 85 || code === 86) return "snow";
  if (code >= 80 && code <= 82) return "rain";
  if (code >= 61 && code <= 67) return "rain";
  if (code >= 51 && code <= 57) return "drizzle";
  if (code === 45 || code === 48) return "fog";
  if (code === 3) return "cloud";
  if (code === 1 || code === 2) return isDay ? "cloud-sun" : "cloud-moon";
  return isDay ? "sun" : "moon";
}

/**
 * Насколько погода в городе НЕ похожа на твою.
 *
 * Ряд городов существует, чтобы показать: прямо сейчас мир звучит по-разному.
 * Поэтому порядок не алфавитный и не случайный — впереди те, где сейчас
 * наиболее иначе. Это и есть ответ на вопрос «почему именно эти города».
 */
export function contrast(
  mine: { temp: number; cloud: number; code: number; isDay: boolean },
  other: { temp: number; cloud: number; code: number; isDay: boolean },
): number {
  const wet = (c: number) => (c >= 51 && c <= 82) || c >= 95;
  const snowy = (c: number) => (c >= 71 && c <= 77) || c === 85 || c === 86;

  let d = 0;
  d += Math.min(1, Math.abs(mine.temp - other.temp) / 30) * 3;     // температура весит больше всего
  d += Math.min(1, Math.abs(mine.cloud - other.cloud) / 100) * 1.2;
  if (wet(mine.code) !== wet(other.code)) d += 1.4;                 // сухо против мокро
  if (snowy(mine.code) !== snowy(other.code)) d += 1.6;             // снег — самый заметный контраст
  if (mine.isDay !== other.isDay) d += 1.5;                         // день против ночи
  return d;
}

/**
 * Суточная кривая температуры как polyline для плитки города.
 * Нормируем по собственному минимуму и максимуму города: читается ФОРМА дня —
 * где ночной провал, где дневной пик, — а не абсолютная величина, которую и
 * так показывает цифра рядом.
 */
export function sparkline(curve: number[], w = 23, h = 10): string {
  if (curve.length < 4) return "";
  const lo = Math.min(...curve);
  const hi = Math.max(...curve);
  const span = hi - lo || 1;
  return curve
    .map((v, i) => {
      const x = (i / (curve.length - 1)) * w;
      const y = h - ((v - lo) / span) * h;
      return `${x.toFixed(1)},${y.toFixed(1)}`;
    })
    .join(" ");
}
